import * as React from "react";

import styled from "styled-components";

const Button = ({
  title,
  variant,
  className,
  onClick,
  defaultSize,
  disabled,
  ...rest
}) => {
  return (
    <ButtonStyled
      variant={variant}
      className={className}
      onClick={onClick}
      disabled={disabled}
      defaultSize={defaultSize}
      {...rest}
    >
      {title}
    </ButtonStyled>
  );
};

const ButtonStyled = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${(props) => (props.defaultSize ? "15rem" : null)};
  height: ${(props) => (props.defaultSize ? "3rem" : null)};
  max-width: 22rem;
  padding: 0.5em 1em;

  position: relative;

  background: ${(props) =>
    props.variant === "outlined" ? "transparent" : props.theme.colors.green};
  border: ${(props) =>
    props.variant === "outlined"
      ? `1px solid ${props.theme.colors.green}`
      : "none"};

  color: ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fonts.futura};
  font-size: 1.2rem;

  transition: 0.2s all;

  &:before {
    content: ${(props) => (props.variant === "solid" ? "" : "''")};

    width: 100%;
    height: calc(100% + 2px);

    position: absolute;
    right: -1px;
    top: -1px;

    background: linear-gradient(
      110deg,
      transparent,
      80%,
      ${(props) => props.theme.colors.black}
    );
  }

  &:hover {
    &:before {
      content: unset;
    }
    box-shadow: ${(props) =>
      props.variant === "solid" ? `0px -3px 8px 1px rgba(47,163,0,0.7)` : null};
  }

  &:disabled{
    opacity: .5;

    &:hover{
      box-shadow:none;
      cursor: default;
    }
  }

  @media ${(props) => props.theme.breakpoints.small} {
    font-size: 1.1rem;
    height: 2.5rem;
  }
`;

export default Button;
